import { AbstractDictionary } from "./AbstractDictionary";
export class DicEducationDocumentType extends AbstractDictionary {
  static NAME = "tsadv_DicEducationDocumentType";
}
export type DicEducationDocumentTypeViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "dicEducationDocumentType-edit";
export type DicEducationDocumentTypeView<
  V extends DicEducationDocumentTypeViewName
> = V extends "_base"
  ? Pick<
      DicEducationDocumentType,
      | "id"
      | "langValue"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_local"
  ? Pick<
      DicEducationDocumentType,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_minimal"
  ? Pick<DicEducationDocumentType, "id" | "langValue">
  : V extends "dicEducationDocumentType-edit"
  ? Pick<
      DicEducationDocumentType,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "company"
    >
  : never;
